export default __webpack_public_path__ + "static/media/Fantasy_26.1369aaf0.png";